<section class="benefit-section" *ngIf="benefitContent && benefitContent.benefitActive">
  <div class="box">
    <div class="benefit-wrapper">
      <div class="benefit-details">
        <h2 id="benefitSection" class="sub-heading" [innerHTML]="benefitContent?.heading | safeHtml"></h2>
        <div class="description" [innerHTML]="benefitContent?.description | safeHtml"></div>
        <div class="benefit-icons">
          <mkt-tab-list [enableTagging]="false">
            <ng-container *ngFor="let benefit of benefitContent?.benefits;">
              <mkt-tab-panel [navTitle]="benefit.navTitle" [iconPath]="benefit.iconPath">
                <div class="description">
                  <hr role="presentation" />
                  <div class="triangle" role="presentation" aria-hidden="true"></div>
                  <div class="panel-content" [innerHTML]="benefit.content | adaFriendlyName: 'ignoreHtmlTags' | safeHtml"></div>
                </div>
              </mkt-tab-panel>
            </ng-container>
          </mkt-tab-list>
        </div>
        <button *ngIf="mobileOnly" cdsButton="inlineLink" [innerHTML]="benefitContent?.returnToBenefitText"
          (click)="scroll('#benefitSection')">Return to Benefits</button>
      </div>
    </div>
    <div class="spacer" role="presentation" aria-hidden="true"></div>
  </div>
</section>